import * as rq from '@tanstack/react-query';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace ListLevels {
  export const key = (repository: IWarrantyRepository) => [
    'warranty',
    'get-list-levels',
    repository.key,
  ];

  export type Params = { refetchInterval?: number };
  export type Output = IWarrantyRepository.ListLevelsOutput;

  export function useQuery({ refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(repositories.warranty),
      queryFn: () => repositories.warranty.listLevels(),
    });
  }
}
